import ModalDeleteFilled from '../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import ModalSmallFilled from '../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../utils/hooks/useTwinTranslation'

interface ModalChangeActiveCustomerProps extends ModalEditComponentProps { }

const ModalChangeActiveCustomer: React.FC<ModalChangeActiveCustomerProps> = ({ setOpened, onSubmit, allRowData }) => {
    if (allRowData?.active === false) {
        return <ModalReactivateCustomer {...{ setOpened, onSubmit, allRowData}} />
    } else {
        return <ModalDeleteCustomer {...{ setOpened, onSubmit, allRowData }} />
    }
}


interface ModalReactivateCustomerProps extends ModalEditComponentProps { }

const ModalReactivateCustomer: React.FC<ModalReactivateCustomerProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/customer/updateCustomer',
        data: {
            id: allRowData?.id,
            active: true
        }
    })
    return (
        <ModalSmallFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureReactiveThisCustomer', '¿Seguro que quieres reactivar este cliente?'),
            subtitle: t('onceReactivatedAbleInCustomerList', 'Una vez reactivado volverá a aparecer en el listado de clientes'),
            buttonAccept: t('reactivate', 'Reactivar')
        }} />
    )
}


interface ModalDeleteCustomerProps extends ModalEditComponentProps { }

const ModalDeleteCustomer: React.FC<ModalDeleteCustomerProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/customer/updateCustomer',
        data: {
            id: allRowData?.id,
            active: false
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteCustomer', '¿Seguro que quieres eliminar este cliente?'),
            subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminado no podrás recuperarlo')
        }} />
    )
}

export default ModalChangeActiveCustomer